import * as client_hooks from '../../../src/hooks.client.ts';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50')
];

export const server_loads = [0];

export const dictionary = {
		"/": [2],
		"/(app)/activate": [3],
		"/(auth)/auth/login": [49],
		"/(app)/auth/signup": [4],
		"/(app)/auth/sso/return": [5],
		"/(app)/confirmations": [6],
		"/(app)/contact": [7],
		"/(app)/contact/summary": [8],
		"/(app)/dashboard": [9],
		"/(app)/demo-v2": [14],
		"/(app)/demo-v2/camera-access": [15],
		"/(app)/demo-v2/correction": [16],
		"/(app)/demo-v2/errors": [17],
		"/(app)/demo-v2/improved-result": [18],
		"/(app)/demo-v2/initial-result": [19],
		"/(app)/demo-v2/lead-choice": [21],
		"/(app)/demo-v2/lead": [20],
		"/(app)/demo-v2/record": [22],
		"/(app)/demo-v2/signup": [23],
		"/(app)/demo": [10],
		"/(app)/demo/camera-access": [11],
		"/(app)/demo/exercise": [~12],
		"/(app)/demo/start-exercise": [13],
		"/(app)/documents/privacy-policy": [24],
		"/(app)/email-verification": [25],
		"/(app)/email-verification/verify": [26],
		"/(app)/error/no-camera-access": [27],
		"/(app)/error/speech": [28],
		"/(app)/help": [29],
		"/(app)/install": [30],
		"/(app)/onboarding": [31],
		"/(app)/onboarding/camera-access": [32],
		"/(app)/onboarding/change-email": [33],
		"/(app)/onboarding/confirmations": [34],
		"/(app)/onboarding/exercise": [~35],
		"/(app)/onboarding/finish": [36],
		"/(app)/onboarding/registration": [37],
		"/(app)/onboarding/start-exercise": [38],
		"/(app)/onboarding/start-premium": [39],
		"/(app)/onboarding/survey": [40],
		"/(app)/password-reset": [41],
		"/(app)/password-reset/token": [42],
		"/(app)/profile": [43],
		"/(app)/profile/admin": [44],
		"/(app)/sets": [45],
		"/(app)/sets/details": [46],
		"/(app)/sets/exercise": [47],
		"/(app)/sets/sessionSummary": [48],
		"/test-sentry": [50]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
	init: client_hooks.init,
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.svelte';